import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { Link, useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import OfficeImg from '../../assets/office.png'
import "./orgStyle.css"

const Parent = () => {
    const [parent, setParent] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [loadingRemove, setLoadingRemove] = useState(false)

    const { organization } = useParams()

    useEffect(() => {
        const getParentOrg = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/parent`)                
                setIsLoading(false)
                setParent(response.data.parentOrg)
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data?.message)
            } finally { setIsLoading(false) }
        }

        getParentOrg()
    }, [organization])

    const handleRemove = async (id) => {
        setLoadingRemove(true)
        try {
            const response = await api.patch(`/${organization}/parent`,{parent:id})
            if (response) {
                setParent(undefined)
                toast.success("parent organization removed")
            }
        } catch (error) {
            setLoadingRemove(false)
            toast.error(error.response.data?.message)
        }finally{
            setLoadingRemove(false)
        }
    }
    return (
        <div className='parent-org-card'>
            {isLoading && <Loader />}
            {
                parent && <div className="parent-org-info">
                    <img src={parent?.logo ? parent.logo.url : OfficeImg} alt="" />
                    <div className="parent-desc">
                        <Link to={`/${parent.name}`}>
                            <h3>{parent.name}</h3>
                        </Link>
                        <p>
                            {parent.description
                                ? parent.description.length > 50
                                    ? `${parent.description.substring(0, 50)}...`
                                    : parent.description
                                : "No description available"}
                        </p>

                        <button className="parent-org-card-btn" onClick={() => handleRemove(parent._id)}>{!loadingRemove ? "Remove" : "..."}</button>
                    </div> 
                </div> 
            }
            {!parent &&!isLoading &&<p className='not-foung-msg'>Organization has no parent added</p>}
        </div>
    )
}

export default Parent